module.exports = __webpack_public_path__ + "static/media/iamthatiam5.d6b15bdb.jpg";